module.exports = __webpack_public_path__ + "assets/img/three.5bf46a3a.jpg";